/**
 * The refund window, as one reading — the landing card, the event page's entry
 * point and the return page all decide from this function, so they agree on
 * every render.
 *
 * Its own module rather than `request.state.ts` because that file imports
 * `landing.state.ts`, so landing cannot import back: the shared reading has to
 * sit below both.
 *
 * The reading is of the clock at call time and Date.now() is no signal, so a
 * `computed` over it recomputes only when some other dep it reads emits — the
 * answer follows state changes, not the window boundary passing under a page
 * left open.
 */
import type { Event } from "@momo/types";

/** `refund` absent means returns are closed and always were; otherwise the
 *  window decides, inclusive at both ends. */
export type RefundWindowPhase = "open" | "closed" | "not-yet" | "unconfigured";

export function refundWindowPhase(
	event: Pick<Event.Event, "refund">,
): RefundWindowPhase {
	const refund = event.refund;
	if (!refund) return "unconfigured";
	const now = Date.now();
	if (now < refund.window.start.toMillis()) return "not-yet";
	if (now > refund.window.end.toMillis()) return "closed";
	return "open";
}
